export default __webpack_public_path__ + "static/media/ai.a7716894.svg";